import React, { createRef, useEffect, useState } from 'react'
import { Row, Col, Form, Card, Button, Divider, Checkbox, message, Modal, Input, Dropdown, Menu, Switch } from 'antd'
import { connect } from 'react-redux'


import './index.scss'
import { getCurrentCompany } from "../../../../services/user";
import TableComponent from "components/Table";
import { Spinner } from "constants/constants";
import SelectField from "components/SelectField";
import SearchableColumn from "components/Table/ColumnSearch";
import CustomTooltip from "components/Tooltip";
import { addStr, dateFormatter, financial } from "../../../../services/helper";
import {
    AccountDetailsIco, AccountExtractIco,
    AccountMoreIco, ArrowDownIco, ArrowUpIco, CardBlocked, CardUnblocked, LimitlerIco,
    NewTransferIco, ReloadIco2, ResetPinTrying, SmsInfo, TabsInfoIco, TeslifatIcon,
    TransfersIco
} from "../../../../../modules/CustomIcons";
import Icon, { InfoCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import SortableColumn from "components/Table/ColumnSort";
import { Link, useHistory, useLocation } from "react-router-dom";
import visa_card from "../../../../../assets/images/visa_card.png";
import master_card from "../../../../../assets/images/master_card.png";
import { getOldCardBalance, getOldCards, OldCards } from "../../../../services/BrCards/OldCards";
import EnableOrDisableServiceModal from "components/EnableOrDisableServiceModal";
import SuccessOrErrorModal from "components/SuccessOrErrorModal";
import moment from 'moment';
import {updateAccountNickname} from "../../../../services/Accounts/AccountNickname";
import {getNewCards} from "../../../../services/BrCards/NewCards";
import { useTranslation } from 'react-i18next';
import {getRequisiteData, setMoreDetail} from "store/actions/accountStatement";
import {useActions} from "hooks/useActions";
import NextModal from "components/NextModalAccount";
import {footerBtnsSecondModal} from "pages/Transfers/StatusRender";
import {getRequisite} from "../../../../services/account";



const IndividualCard: React.FC<any> = (props) => {
    const {t} = useTranslation();
    const language = localStorage.getItem("i18nextLng")

    const blockOrUnblockServicePopupDataInitial = {
        serviceType: 'activate',
        activateBtnText: t("businessCards.blockCard"),
        modalTitle: t("businessCards.blockCard"),
        modalText: t("businessCards.noOperationNotif"),
        successModalTitle: t("businessCards.isReady"),
        successModalText: t("businessCards.cardBlocked")
    }

    const statusList = [
        {
            value: 'all',
            label: t("common.all")
        },
        {
            value: 'Active',
            label: t("salary.active")
        },
        {
            value: 'Blocked',
            label: t("home.blocked")
        },
        {
            value: 'Deactive',
            label: t("businessCards.deactive")
        }
    ]

    const [tableLoading, setTableLoading] = useState(Spinner)
    const [tableDataMain, setTableDataMain] = useState();
    const [tableData, setTableData] = useState<OldCards>();
    const [tableDataForSort, setTableDataForSort] = useState<OldCards>();
    const [expandedRowKeys, setExpandedRowKeys] = useState<any>([]);
    const [enableOrDisableSmsNotif, setEnableOrDisableSmsNotif] = useState<boolean>(false)
    const [visibleBlockUnblockCardModal, setVisibleBlockUnblockCardModal] = useState<boolean>(false)
    const [visibleResetPinModal, setVisibleResetPinModal] = useState<boolean>(false)
    const [visibleSmsNotifModal, setVisibleSmsNotifModal] = useState<boolean>(false)
    const [blockOrUnblockServicePopupData, setBlockOrUnblockServicePopupData] = useState(blockOrUnblockServicePopupDataInitial)
    const [selectedRow, setSelectedRow] = useState<any>()
    const [titleRequisiteState, setTitleRequisiteState] = useState<Array<any>>([]);
    const [requisiteModalVisible, setRequisiteModalVisible] = useState(false);
    const [requisiteData,setreqData] = useState({})
    const [form] = Form.useForm();

    const location = useLocation();

    const { setMoreDetail, getRequisiteData} = useActions();

    const [filtereValuesSubCard, setFilteredValuesSubCard] = useState<any>([])

    useEffect(() => {
            fetchData();

    }, [location.pathname]);


    const toggleMoreTable = (record) => {

        let key = record.key,
            check_index = expandedRowKeys.indexOf(key);

        if (check_index === - 1) {
            setExpandedRowKeys(old_array => [...expandedRowKeys, key]);
        } else {
            expandedRowKeys.splice(check_index, 1);

            setExpandedRowKeys(old_array => [...expandedRowKeys]);
        }

    }

    const enableOrDisableSmsNotification = () => {
        setEnableOrDisableSmsNotif(old_data => true);
        setVisibleSmsNotifModal(old_data => true)
    }

    const showCardBlockOrUnblockModal = () => {
        setVisibleBlockUnblockCardModal(old_data => true);

        if (selectedRow?.BlockedBy === 'Bank' || selectedRow?.CardStat === 'Blocked') {
            setBlockOrUnblockServicePopupData(old_data => {
                return {
                    serviceType: 'deactivate',
                    activateBtnText: t("businessCards.unblock"),
                    modalTitle: t("businessCards.unblock"),
                    modalText: t("businessCards.unblockNotif"),
                    successModalTitle: t("businessCards.isReady"),
                    successModalText: t("businessCards.cardUnblocked")
                }
            })
        } else {
            setBlockOrUnblockServicePopupData(old_data => blockOrUnblockServicePopupDataInitial)
        }
    }

    // const sendMoreDetailFunc = (key: string, iban: string, from: string) => {
    //
    //     setMoreDetail({key: key, iban: iban, from: from});
    // }


    const tableDropDown =(record:any)=> (

        <Menu className='hesablar_dropdown business_cards_dropdown '>

            <Menu.Item className={'is_disabled'} icon={<Icon component={() => (<AccountDetailsIco />)} />}>
                {t("businessCards.cardAccountDetails")}
            </Menu.Item>

            {/*<Menu.Item className={''} icon={<Icon component={() => (<TeslifatIcon className='teslifatlar_ico' />)} onClick={() => { sendMoreDetailFunc(record.key, record.col_1.subtitle, "tefsilat") }}/>}>*/}
            {/*    <Link to={'/accounts/accounts'} >{t("home.details")}</Link>*/}
            {/*</Menu.Item>*/}
            <Menu.Item className={'is_disabled'} icon={<Icon component={() => (<TeslifatIcon />)} />}>
                {t("home.details")}
            </Menu.Item>

            <Menu.Item className={''} icon={<Icon component={() => (<AccountExtractIco />)} />}>
                <Link to={{pathname:'/business_cards/card_account_statement',state:{iban:selectedRow?.col_1.subtitle}}} >{t("businessCards.cardAccountStatement")}</Link>
            </Menu.Item>

            <Menu.Item className={''} icon={<Icon component={() => (<AccountExtractIco />)} />}>
                <Link to={{pathname:'/business_cards/card_accountpan_statement',state:{card:selectedRow?.col_2}}} > {t("businessCards.cardStatement")}</Link>
             </Menu.Item>

            <Divider />

            <Menu.Item className={'is_disabled'} icon={<Icon component={() => (<LimitlerIco />)} />}>
                {t("businessCards.limits")}
            </Menu.Item>

            {
                selectedRow?.row?.BlockedBy !== 'User' && selectedRow?.row?.CardStat === 'Blocked' ?
                    <CustomTooltip title={selectedRow?.col_7.card_balance === '-' ? (language=="az"?`Kart ${selectedRow?.row?.BlockedDate} tarixində bloklanıb. <br/> Ətraflı məlumat üçün balansı yeniləyin.` :language=="ru" ? `Карта заблокирована ${selectedRow?.row?.BlockedDate} года. <br/> Обновите баланс для получения подробной информации` : language=="en" ? `The card was blocked on ${selectedRow?.row?.BlockedDate}. <br/>Update the balance for more information.`:"" ): `Kart ${selectedRow?.row?.BlockedDate} tarixində bank tərəfindən bloklanıb. <br/> Blokdan çıxarmaq üçün banka müraciət etməyiniz xahiş olunur.`}>
                        <Menu.Item className={'is_disabled'} icon={<Icon component={() => (<CardUnblocked />)} />}>
                            {t("businessCards.unblockCard")}
                        </Menu.Item>
                    </CustomTooltip>
                    : (selectedRow?.row?.CardStat === 'Blocked') ? <Menu.Item className={`${selectedRow?.col_7.card_balance === '-' ? 'is_disabled' : ''} `} onClick={showCardBlockOrUnblockModal} icon={<Icon component={() => (<CardUnblocked />)} />}>
                        {t("businessCards.unblockCard")}
                    </Menu.Item> : <Menu.Item
                        className={'is_disabled'}
                        // onClick={showCardBlockOrUnblockModal} 
                        icon={<Icon component={() => (<CardBlocked />)} />}>
                       {t("businessCards.blockCard")}
                    </Menu.Item>
            }

            <Menu.Item
                className={'is_disabled'}
                // onClick={(e) => setVisibleResetPinModal(old_data => true)} 
                icon={<Icon component={() => (<ResetPinTrying />)} />}>

                {
                    selectedRow?.row?.BlockedBy !== 'User' && selectedRow?.row?.CardStat === 'Blocked' && selectedRow?.col_7.card_balance !== '-' ? <CustomTooltip title={`Kart ${selectedRow?.row?.BlockedDate} il tarixində bank tərəfindən bloklanıb. <br/> Blokdan çıxartmaq üçün banka müraciət etməyiniz xahiş olunur.`}>
                        {t("businessCards.resetPINEntryAttempt")}
                    </CustomTooltip> : t("businessCards.resetPINEntryAttempt")
                }
            </Menu.Item>

            <Menu.Item className={'is_disabled flex align_center justify_between'} icon={<Icon component={() => (<SmsInfo />)} />}>
                <p className={'flex align_center'} >
                    {t("businessCards.SMSNotification")}

                    <CustomTooltip title={t("businessCards.SMSNotificationDescription")} >
                        <Button type={"ghost"} className={'trasparent info_icon'} icon={<TabsInfoIco />} />
                    </CustomTooltip>

                </p>

                <Switch
                    checked={enableOrDisableSmsNotif}
                // onChange={enableOrDisableSmsNotification} 
                />
            </Menu.Item>

            {/* <Menu.Item className={'is_disabled'} icon={<Icon component={() => (<LimitlerIco   />)} />}>
                {t("businessCards.limits")}
            </Menu.Item>

            {
                selectedRow?.row?.BlockedBy!=='User' && selectedRow?.row?.CardStat==='Blocked' ?
                    <CustomTooltip title={selectedRow?.col_7.card_balance==='-' ? `Kart ${selectedRow?.row?.BlockedDate} tarixində bloklanıb. <br/> Ətraflı məlumat üçün balansı yeniləyin.` : `Kart ${selectedRow?.row?.BlockedDate} tarixində bank tərəfindən bloklanıb. <br/> Blokdan çıxarmaq üçün banka müraciət etməyiniz xahiş olunur.`} >
                        <Menu.Item className={'is_disabled'} icon={<Icon component={() => (<CardUnblocked  />)} />}>
                            {t("businessCards.unblockCard")}
                        </Menu.Item>
                    </CustomTooltip>
                     : (selectedRow?.row?.CardStat==='Blocked') ? <Menu.Item className={`${selectedRow?.col_7.card_balance==='-' ? 'is_disabled' : ''} `} onClick={showCardBlockOrUnblockModal} icon={<Icon component={() => (<CardUnblocked  />)} />}>
                        {t("businessCards.unblockCard")}
                    </Menu.Item> : <Menu.Item onClick={showCardBlockOrUnblockModal} icon={<Icon component={() => (<CardBlocked  />)} />}>
                        {t("businessCards.blockCard")}
                    </Menu.Item>
            }

            <Menu.Item  onClick={(e) => setVisibleResetPinModal(old_data => true)} icon={<Icon component={() => (<ResetPinTrying  />)} />}>

                {
                    selectedRow?.row?.BlockedBy!=='User' && selectedRow?.row?.CardStat==='Blocked' && selectedRow?.col_7.card_balance!=='-' ? <CustomTooltip title={`Kart ${selectedRow?.row?.BlockedDate} il tarixində bank tərəfindən bloklanıb. <br/> Blokdan çıxartmaq üçün banka müraciət etməyiniz xahiş olunur.`}>
                        {t("businessCards.resetPINEntryAttempt")}
                    </CustomTooltip> : t("businessCards.resetPINEntryAttempt")
                }
            </Menu.Item>

            <Menu.Item className={'flex align_center justify_between'} icon={<Icon component={() => (<SmsInfo  />)} />}>
                <p className={'flex align_center'} >
                    {t("businessCards.SMSNotification")}

                    <CustomTooltip title={t("businessCards.SMSNotificationDescription")} >
                        <Button type={"ghost"} className={'trasparent info_icon'} icon={<TabsInfoIco />} />
                    </CustomTooltip>

                </p>

                <Switch checked={enableOrDisableSmsNotif} onChange={enableOrDisableSmsNotification} />
            </Menu.Item> */}

        </Menu>
    );

    const [filtereValues, setFilteredValues] = useState({ "col_1": "", "col_3": "", "col_4": "" })

    const filterMainCard = (e: any, column: string) => {

        let newfiltereValues = filtereValues;

        if (column === 'card_name') {
            newfiltereValues.col_1 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'account_name_or_iban') {
            newfiltereValues.col_1 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }
        if (column === 'card_owner') {
            newfiltereValues.col_3 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }
        if (column === 'main_status_filter') {
            newfiltereValues.col_4 = e?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (tableDataMain) {
            let filteredData;
            filteredData = tableDataMain?.filter(sRow => sRow.col_1.title.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_1"]) && sRow.col_3.card_owner.toLowerCase().includes(filtereValues["col_3"]) && sRow.col_4.CardStat.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_4"]));

            setTableData(old_data => filteredData)
            setTableDataForSort(old_data => filteredData)

            if (filtereValues["col_4"] === 'all') {
                form.resetFields(['main_status_filter'])
            }

        }

    }

    const filterSubCard = (e: any, column: string, ind: any) => {

        let newfiltereValuesCard = filtereValuesSubCard;

        if (column === 'card_name') {
            newfiltereValuesCard[ind].col_1 = e.target.value?.toLowerCase()
            setFilteredValuesSubCard(newfiltereValuesCard)
        }

        if (column === 'card_pan') {

            newfiltereValuesCard[ind].col_2 = e.target.value?.toLowerCase()
            setFilteredValuesSubCard(newfiltereValuesCard)
        }

        if (column === 'card_user') {
            newfiltereValuesCard[ind].col_3 = e.target.value?.toLowerCase()
            setFilteredValuesSubCard(newfiltereValuesCard)
        }

        if (column === 'status_filter') {
            newfiltereValuesCard[ind].col_4 = e?.toLowerCase()
            setFilteredValuesSubCard(newfiltereValuesCard)
        }

        if (tableDataMain && filtereValuesSubCard) {
            let new_array = [];

            tableDataMain?.map((row: any, i: number) => {


                let AdditionCards = row.row.AdditionCards;
                let data = row.data;



                if (AdditionCards.length > 0) {
                    let filterAdditionCards = AdditionCards;
                    let filterData = data;

                    filterAdditionCards = filterAdditionCards.filter(sRow => sRow.Name?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValuesSubCard[i]["col_1"]) && sRow.EncryptedPan.normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValuesSubCard[i]["col_2"]) && (sRow.CardHolder ? sRow.CardHolder?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValuesSubCard[i]["col_3"]) : sRow.CardHolder === null) && sRow.CardStat?.toLowerCase().includes(filtereValuesSubCard[i]["col_4"]));

                    filterData = filterData.filter(sRow => sRow.col_1.title?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValuesSubCard[i]["col_1"]) && sRow.col_2.card_number.normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValuesSubCard[i]["col_2"]) && (sRow.col_3.card_owner ? sRow.col_3.card_owner?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValuesSubCard[i]["col_3"]) : sRow.col_3.card_owner === null) && sRow.col_4.CardStat?.toLowerCase().includes(filtereValuesSubCard[i]["col_4"]));


                    new_array.push({
                        ...row,
                        data: filterData,
                        row: { ...row.row, AdditionCards: filterAdditionCards }
                    })


                } else {
                    new_array.push(row);
                }
            })


            setTableData(old_data => new_array)
            setTableDataForSort(old_data => new_array)
            if (filtereValuesSubCard[ind]["col_4"] === 'all') {
                form.resetFields(['status_filter' + ind])
            }
        }
    }

    const updateAccountName = (e: any, row: any) => {
        let value = e.target.value.trim();
        let check_value = value.length > 0 ? value : '' /*getAccountType(row.ACCOUNT_TYPE)*/;

        const requestData = {
            IBAN: row.subtitle,
            NICKNAME: check_value
        }

        setTableLoading({
            ...tableLoading,
            spinning: true
        });

        updateAccountNickname(requestData).then(res => {
            if(res?.messages !== undefined && res?.messages !== null && res?.messages.length > 0 && res?.messages[0].MESSAGE === "SUCCESS")
                updateData()
        })

    }

    const updateData = () => {
        getOldCards(getCurrentCompany()).then(res => {
            setTableLoading({
                ...tableLoading,
                spinning: true
            });

            let temp_array = [];
            let filtereValueInitial = []
            // const data = await getOldCards(getCurrentCompany());
            // const cards = data?.oldBusinessCards?.MainCards;

            const cards = res?.oldBusinessCards?.MainCards;
            props.updateOldCard(res);
            if (cards) {
                cards.map((row: any, i: number) => {
                    let get_key = row.EncryptedPan.split(' '),
                        key = get_key[0] + get_key[get_key.length - 1];
                    filtereValueInitial.push({ "col_1": "", "col_2": "", "col_3": "", "col_4": "" });
                    let blocked_tooltip = `Kart ${row?.BlockedDate} tarixində bloklanıb. <br/> Ətraflı məlumat üçün balansı yeniləyin.`;


                    let tempRow = {
                        ind: i,
                        key: key,
                        col_1: { title: row.nickName !== null ? row.nickName : row.Name, subtitle: row.Iban, tooltip: row.nickName !== null ? row.nickName : row.Name },
                        col_2: { card_type: row.PaymentSys.toLowerCase(), card_number: row.EncryptedPan, card_count: row.AdditionNumb, card_pan: row.Pan },
                        col_3: { card_owner: row.CardHolder },
                        col_4: { card_status: row.CardStat === 'Blocked' ? t("home.blocked") : t("salary.active"), card_blocked: row.CardStat === 'Blocked', tooltip: blocked_tooltip, CardStat: row.CardStat },
                        col_5: { card_expire_date: row.ExpDate },
                        col_6: { card_currency: row.Currency },
                        col_7: { card_balance: '-' },
                        nickname: row.nickName ,
                        row: { ...row, card_balance: '-' },
                        data: []
                    }

                    if (row.AdditionNumb > 0) {
                        let subCards = [];

                        for (let subCard of row.AdditionCards) {
                            let get_key = subCard.EncryptedPan.split(' '),
                                key = get_key[0] + get_key[get_key.length - 1];

                            let blocked_tooltip = `Kart ${subCard?.BlockedDate} tarixində bloklanıb. <br/> Ətraflı məlumat üçün balansı yeniləyin.`;

                            subCards.push({
                                key: key,
                                col_1: { title: subCard.nickName !== null ? subCard.nickName : subCard.Name, subtitle: subCard.Pan },
                                col_2: { card_type: subCard.PaymentSys.toLowerCase(), card_number: subCard.EncryptedPan, card_pan: subCard.Pan },
                                col_3: { card_owner: subCard.CardHolder },
                                col_4: { card_status: subCard.CardStat === 'Blocked' ? t("home.blocked") : t("salary.active"), card_blocked: subCard.CardStat === 'Blocked', tooltip: blocked_tooltip, CardStat: subCard.CardStat },
                                col_5: { card_expire_date: subCard.ExpDate },
                                col_6: { card_currency: subCard.Currency },
                                nickname: subCard.nickName ,
                                row: subCard
                            })
                        }

                        tempRow = { ...tempRow, data: subCards };
                    }

                    // @ts-ignore
                    temp_array.push(tempRow);
                })
            }

            setTableLoading({
                ...tableLoading,
                spinning: false
            });
            setTableData(old_data => temp_array)
            setTableDataForSort(old_data => temp_array)
            setTableDataMain(old_data => temp_array)

            setFilteredValuesSubCard(filtereValueInitial)
        });

        // getNewCards(getCurrentCompany()).then(res => {
        //         newCard: (res.newBusinessCards?.MainCards?.length > 0) ? 'true' : 'false'
        // })
    }

    const accountTableColumns = [
        {
            title: (
                <>
                    <div>
                        <Form
                            form={form}
                        >
                            <SearchableColumn
                                title={t("businessCards.accountNameIban")}
                                name={'account_name_or_iban'}
                                onChange={(event: any) => filterMainCard(event, "account_name_or_iban")}
                                form={form}
                                filter={"searchfilter"}
                            />
                        </Form>
                    </div>
                </>
            ),
            dataIndex: 'col_1',
            key: 'col_1',
            className: 'col_1 ant-table-cell-ellipsis',
            render: (data,alldata) => (
                <>
                    {/*<CustomTooltip title={data.tooltip}  >*/}
                    <p className=' align_center not_open_popup' >
                        <div className={'not_open_popup account_edit_nickname account_searchable'} >
                            <Form
                                form={form}
                            >
                                <SearchableColumn
                                    large
                                    title={data.title}
                                    customIcon={true}
                                    form={form}
                                    allowClear={true}
                                    value={data.title}
                                    nickname={alldata.nickname}
                                    name={'updateAccountName1'}
                                    /*onChange={(e) => updateAccountName(e, data.subtitle)}*/
                                    onBlur={(e) => updateAccountName(e, data)}
                                />
                            </Form>
                        </div>
                    </p>
                    {/*</CustomTooltip>*/}
                    <span className='business_card_iban'>{data.subtitle}</span>

                </>
            ),
            ellipsis: true,
            width: 103,
        },
        {
            title: (
                <div>
                    {t("businessCards.cardNumberPAN")}
                </div>
            ),
            dataIndex: 'col_2',
            key: 'col_2',
            className: ` col_2 `,
            ellipsis: true,
            width: 130,
            editable: false,
            render: (data, record) => {
                let card_src = data.card_type == 'visa' ? visa_card : master_card;
                let card_number = data.card_number.split(' ');
                let show_card_number = data.card_count > 0 ? `${card_number[1]} ${card_number[card_number.length - 1]}` : data.card_number;

                return (
                    <div className={'flex align_center full_h'}>
                        <img className={'card_type_img'} src={card_src} />
                        {/*<CustomTooltip title={data.card_pan.replace(/(\w{4})(\w{4})(\w{4})(\w{4})/, "$1 $2 $3 $4")} className={'businesscard_tooltip'}>*/}
                            <p >{show_card_number}</p>
                        {/*</CustomTooltip>*/}

                        {
                            data.card_count > 0 &&
                            <Button
                                type={"ghost"}
                                icon={expandedRowKeys.indexOf(record.key) !== -1 ? <ArrowUpIco /> : <ArrowDownIco />}
                                className={'show_card_count_btn '}
                                onClick={() => toggleMoreTable(record)}
                            >{data.card_count}</Button>

                        }
                    </div>
                )
            }
        },
        {
            title: (
                <div>
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            title={t("businessCards.user")}
                            name={'card_owner'}
                            onChange={(event: any) => filterMainCard(event, "card_owner")}
                            form={form}
                            filter={"searchfilter"}
                        />
                    </Form>
                </div>
            ),
            dataIndex: 'col_3',
            key: 'col_3',
            className: ' col_3',
            ellipsis: true,
            width: 130,
            editable: false,
            render: text => {
                return (
                    <p>{text.card_owner}</p>
                )
            }
        },
        {
            title: (
                <div>
                    <Form
                        form={form}
                    >
                        <SelectField
                            placeholder={t("credits.creditStatus")}
                            options={statusList}
                            className="status-select"
                            onChange={(event: any) => filterMainCard(event, "main_status_filter")}
                            name={'main_status_filter'}
                            label
                        />
                    </Form>
                </div>
            ),
            dataIndex: 'col_4',
            key: 'col_4',
            className: 'col_4',
            ellipsis: true,
            width: 230,
            editable: false,
            render: text => {
                let p_classname = text.card_blocked ? 'has_blocked_amount' : 'no_blocked_amount';

                return (
                    <>
                        <p className={p_classname} >{text.card_status}</p>
                        {
                            text.card_blocked && <CustomTooltip title={text.tooltip}>
                                <Button className='has_blocked_data transparent' icon={<InfoCircleOutlined />} />
                            </CustomTooltip>
                        }
                    </>
                )
            }
        },
        {
            title: (
                <div className="finished_date sort_col">
                    <SortableColumn
                        data={tableData}
                        setData={setTableData}
                        dataOriginal={tableDataForSort}
                        type={"date"}
                        parameter={"col_5"}
                        paramater_second={"card_expire_date"}
                    />
                    <span>{t("salary.expiryDate")}</span>
                </div>
            ),
            dataIndex: 'col_5',
            key: 'col_5',
            className: 'col_5',
            ellipsis: true,
            width: 250,
            editable: false,
            // sorter: (a, b) => moment(a.col_5.card_expire_date, "DD.MM.YYYY").unix() - moment(b.col_5.card_expire_date, "DD.MM.YYYY").unix(),
            render: (text) => {
                let expire_date = dateFormatter(text.card_expire_date, 'MMMM DD, YYYY HH:mm:ss', 'DD.MM.YYYY');
                let p_class = '';
                const dateNow: Date = new Date();
                const dateExpire: Date = new Date(expire_date);

                if (dateExpire < dateNow) {
                    p_class = ' card_expired '
                } else if (
                    parseInt(dateFormatter(text.card_expire_date, 'M', 'DD.MM.YYYY')) === (dateNow.getMonth() + 1) &&
                    parseInt(dateFormatter(text.card_expire_date, 'YYYY', 'DD.MM.YYYY')) === dateNow.getFullYear()
                ) {
                    p_class = ' card_expired_this_month '
                }

                return (
                    <p className={p_class} >{text.card_expire_date}</p>
                )
            }
        },
        {
            title: (
                <div className="required-column ">
                    <span>{t("home.currency")}</span>
                </div>
            ),
            dataIndex: 'col_6',
            key: 'col_6',
            className: 'col_6',
            ellipsis: true,
            width: 209,
            editable: false,
            render: text => {

                return <p >{text.card_currency}</p>
            }
        },
        {
            title: (
                <div className="flex align_center full justify_end sort_col">
                    <SortableColumn
                        data={tableData}
                        setData={setTableData}
                        dataOriginal={tableDataForSort}
                        type={"number"}
                        parameter={"col_7"}
                        paramater_second={"card_balance"}
                    />
                    <span>{t("home.balance")}</span>
                </div>
            ),
            dataIndex: 'col_7',
            key: 'col_7',
            className: 'col_7',
            ellipsis: true,
            width: 100,
            editable: false,

            // sorter: (a, b) => {
            //     if (isNaN(Number(a.col_7.card_balance))) {
            //         return 1 - isNaN(Number(b.col_7.card_balance));
            //     }
            //     else if (isNaN(Number(b.col_7.card_balance))) {
            //         return isNaN(Number(a.col_7.card_balance)) - 1;
            //     }
            //     else {
            //         return Number(a.col_7.card_balance) - Number(b.col_7.card_balance);
            //     }
            // },
            render: (text, record) => (
                <p className={parseFloat(text.card_balance) > 0 ? 'has_balance' : 'no_balance'}>{text.card_balance}</p>
            ),
        },
        {
            title: (
                <CustomTooltip title={t("businessCards.updateAllBalances")} >
                    <Button icon={<ReloadIco2 />} onClick={() => updateBalance('allBalance')} className='transparent box_reload_ico' />
                </CustomTooltip>
            ),
            dataIndex: 'col_8',
            key: 'col_8',
            className: 'col_8',
            ellipsis: true,
            width: 100,
            editable: false,
            render: (text, record) => (
                <div className='flex align_center justify_end account_operation_table_button btn_box'>
                    <CustomTooltip title={t("businessCards.updateBalance")} >
                        <Button icon={<ReloadIco2 />} onClick={() => updateBalance(record.row)} className='transparent box_reload_ico' />
                    </CustomTooltip>
                </div>
            ),
        },
        {
            title: '',
            dataIndex: 'col_9',
            key: 'col_9',
            className: 'col_9 dropdown_3dot',
            ellipsis: true,
            width: 100,
            editable: false,
            render: (text, record) => (
                <div className={'btn_box flex align_center justify_center'} >
                    <Dropdown overlay={tableDropDown(record)} trigger={'click'} onClick={(e) => { setSelectedRow(old_data => record) }} placement="bottomRight" >
                        <Button icon={<AccountMoreIco />} className='transparent table_more_btn' />
                    </Dropdown>
                </div>
            ),
        },
    ];

    const fetchData = async () => {

        setTableLoading({
            ...tableLoading,
            spinning: true
        });

        let temp_array = [];
        let filtereValueInitial = []
        // const data = await getOldCards(getCurrentCompany());
        // const cards = data?.oldBusinessCards?.MainCards;

        const cards = props.oldBusinessCardsData?.oldBusinessCards?.MainCards;
        if (cards) {
            cards.map((row: any, i: number) => {
                let get_key = row.EncryptedPan.split(' '),
                    key = get_key[0] + get_key[get_key.length - 1];
                filtereValueInitial.push({ "col_1": "", "col_2": "", "col_3": "", "col_4": "" });
                let blocked_tooltip = `Kart ${row?.BlockedDate} tarixində bloklanıb. <br/> Ətraflı məlumat üçün balansı yeniləyin.`;


                let tempRow = {
                    ind: i,
                    key: key,
                    col_1: { title: row.nickName !== null ? row.nickName : row.Name, subtitle: row.Iban, tooltip: row.nickName !== null ? row.nickName : row.Name },
                    col_2: { card_type: row.PaymentSys.toLowerCase(), card_number: row.EncryptedPan, card_count: row.AdditionNumb, card_pan: row.Pan },
                    col_3: { card_owner: row.CardHolder },
                    col_4: { card_status: row.CardStat === 'Blocked' ? t("home.blocked") : t("salary.active"), card_blocked: row.CardStat === 'Blocked', tooltip: blocked_tooltip, CardStat: row.CardStat },
                    col_5: { card_expire_date: row.ExpDate },
                    col_6: { card_currency: row.Currency },
                    col_7: { card_balance: '-' },
                    row: { ...row, card_balance: '-' },
                    data: []
                }

                if (row.AdditionNumb > 0) {
                    let subCards = [];

                    for (let subCard of row.AdditionCards) {
                        let get_key = subCard.EncryptedPan.split(' '),
                            key = get_key[0] + get_key[get_key.length - 1];

                        let blocked_tooltip = `Kart ${subCard?.BlockedDate} tarixində bloklanıb. <br/> Ətraflı məlumat üçün balansı yeniləyin.`;

                        subCards.push({
                            key: key,
                            col_1: { title: subCard.nickName !== null ? subCard.nickName : subCard.Name, subtitle: subCard.Pan },
                            col_2: { card_type: subCard.PaymentSys.toLowerCase(), card_number: subCard.EncryptedPan, card_pan: subCard.Pan },
                            col_3: { card_owner: subCard.CardHolder },
                            col_4: { card_status: subCard.CardStat === 'Blocked' ? t("home.blocked") : t("salary.active"), card_blocked: subCard.CardStat === 'Blocked', tooltip: blocked_tooltip, CardStat: subCard.CardStat },
                            col_5: { card_expire_date: subCard.ExpDate },
                            col_6: { card_currency: subCard.Currency },
                            row: subCard
                        })
                    }

                    tempRow = { ...tempRow, data: subCards };
                }

                // @ts-ignore
                temp_array.push(tempRow);
            })
        }

        setTableLoading({
            ...tableLoading,
            spinning: false
        });
        setTableData(old_data => temp_array)
        setTableDataForSort(old_data => temp_array)
        setTableDataMain(old_data => temp_array)

        setFilteredValuesSubCard(filtereValueInitial)
    };

    const expandedRowRender = () => {
        const columns = (ind) => [
            {
                title: (
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            divClass={'search_type_2'}
                            title={t("businessCards.cardName")}
                            name={'card_name' + ind}
                            onChange={(event: any) => filterSubCard(event, "card_name", ind)}
                            form={form}
                            filter={"searchfilter"}
                        />
                    </Form>
                ),
                dataIndex: 'col_1',
                key: 'col_1',
                className: 'col_1 ant-table-cell-ellipsis',
                render: data => (
                    <>

                        <CustomTooltip title={data.title}>
                            <p className='text-right'>{data.title}</p>
                        </CustomTooltip>
                    </>
                ),
                ellipsis: true,
                width: 103,
            },
            {
                title: (
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            divClass={'search_type_2'}
                            title={t("businessCards.additionalCards")}
                            name={'card_pan' + ind}
                            onChange={(event: any) => filterSubCard(event, "card_pan", ind)}
                            form={form}
                            filter={"searchfilter"}
                        />
                    </Form>
                ),
                dataIndex: 'col_2',
                key: 'col_2',
                className: ' col_2',
                ellipsis: true,
                width: 130,
                editable: false,
                render: data => {
                    let card_src = data.card_type == 'visa' ? visa_card : master_card;

                    return (
                        <div className={'flex align_center full_h'}>
                            <img className={'card_type_img'} src={card_src} />
                            <CustomTooltip title={data.card_pan}>
                                <p >{data.card_number}</p>
                            </CustomTooltip>
                        </div>
                    )
                }
            },
            {
                title: (
                    <Form
                        form={form}
                    >
                        <SearchableColumn
                            divClass={'search_type_2'}
                            title={t("businessCards.user")}
                            name={'card_user' + ind}
                            onChange={(event: any) => filterSubCard(event, "card_user", ind)}
                            form={form}
                            filter={"searchfilter"}
                        />
                    </Form>
                ),
                dataIndex: 'col_3',
                key: 'col_3',
                className: ' col_3',
                ellipsis: true,
                width: 130,
                editable: false,
                render: text => {
                    return (
                        <p>{text.card_owner}</p>
                    )
                }
            },
            {
                title: (
                    <div>
                        <Form
                            form={form}
                        >
                            <SelectField
                                placeholder={t("credits.creditStatus")}
                                options={statusList}
                                className="status-select"
                                onChange={(event: any) => filterSubCard(event, "status_filter", ind)}
                                name={'status_filter' + ind}
                                label
                            />
                        </Form>
                    </div>
                ),
                dataIndex: 'col_4',
                key: 'col_4',
                className: 'col_4',
                ellipsis: true,
                width: 230,
                editable: false,
                render: text => {

                    let p_classname = text.card_blocked ? 'has_blocked_amount' : 'no_blocked_amount';

                    return (
                        <>
                            <p className={`other_color ${p_classname}`} >{text.card_status}</p>
                            {
                                text.card_blocked && <CustomTooltip title={text.tooltip}>
                                    <Button className='has_blocked_data transparent' icon={<InfoCircleOutlined />} />
                                </CustomTooltip>
                            }
                        </>
                    )

                }
            },
            {
                title: (
                    <div className="finished_date sort_col">
                        <SortableColumn
                            data={tableData}
                            setData={setTableData}
                            dataOriginal={tableDataForSort}
                            type={"date"}
                            parameter={"col_5"}
                            paramater_second={"card_expire_date"}
                            dataIndex={ind}
                        />
                        <span>{t("salary.expiryDate")}</span>
                    </div>
                ),
                dataIndex: 'col_5',
                key: 'col_5',
                className: 'col_5',
                ellipsis: true,
                width: 250,
                editable: false,
                // sorter: (a, b) => moment(a.col_5.card_expire_date, "DD.MM.YYYY").unix() - moment(b.col_5.card_expire_date, "DD.MM.YYYY").unix(),
                render: (text) => {

                    let expire_date = dateFormatter(text.card_expire_date, 'MMMM DD, YYYY HH:mm:ss', 'DD.MM.YYYY');
                    let p_class = '';

                    if (new Date(expire_date) < new Date()) {
                        p_class = ' card_expired '

                    } else if (
                        parseInt(dateFormatter(text.card_expire_date, 'M', 'DD.MM.YYYY')) === (new Date().getMonth() + 1) &&
                        parseInt(dateFormatter(text.card_expire_date, 'YYYY', 'DD.MM.YYYY')) === new Date().getFullYear()
                    ) {
                        p_class = ' card_expired_this_month '
                    }

                    return (
                        <p className={p_class} >{text.card_expire_date}</p>
                    )

                }
            },
            {
                title: (
                    <div className="required-column">
                        <span>{t("home.currency")}</span>
                    </div>
                ),
                dataIndex: 'col_6',
                key: 'col_6',
                className: 'col_6',
                ellipsis: true,
                width: 209,
                editable: false,
                render: text => {

                    return <p >{text.card_currency}</p>
                }
            },
            {
                title: '',
                dataIndex: 'col_7',
                key: 'col_7',
                className: 'col_7',
                ellipsis: true,
                width: 100,
                editable: false,
                render: ''
            },
            {
                title: '',
                dataIndex: 'col_8',
                key: 'col_8',
                className: 'col_8',
                ellipsis: true,
                width: 100,
                editable: false,
                render: ''
            },
            {
                title: '',
                dataIndex: 'col_9',
                key: 'col_9',
                className: 'col_9',
                ellipsis: true,
                width: 100,
                editable: false,
                render: (text, record) => (
                    <div className={'btn_box flex align_center justify_center'} >
                        <Dropdown overlay={tableDropDown} trigger={'click'} onClick={(e) => { setSelectedRow(old_data => record.row) }} placement="bottomRight" >
                            <Button icon={<AccountMoreIco />} className='transparent table_more_btn' />
                        </Dropdown>
                    </div>
                ),
            },
        ];

        return {
            expandedRowRender: (record) => (<TableComponent
                columns={columns(record.ind)}
                data={record.data}
                scroll={{ x: true }}
                pagination={false}
                className=" transfer-table table-hover home_hesab_table  home_content_table business_cards_table business_cards_table_2"
            />),
            rowExpandable: record => record.data,
            expandRowByClick: false,
            expandedRowKeys: expandedRowKeys
        };
    };

    const updateBalance = async (parentRow: any = null) => {

        setTableLoading({
            ...tableLoading,
            spinning: true
        });

        let encryptedPanList = [];
        let hasSubCardList = [];



        if (parentRow === 'allBalance') {

            for (let row of tableData) {
                let EncryptedPan = row.row.EncryptedPan;

                if (EncryptedPan !== undefined) {
                    encryptedPanList.push(EncryptedPan)

                    let Pans: any = [];

                    if (row.row.AdditionNumb > 0) {
                        row.row.AdditionCards.map((item: any) => {
                            let EncryptedPan = item.EncryptedPan;

                            if (EncryptedPan !== undefined) {
                                encryptedPanList.push(EncryptedPan)
                                Pans.push({
                                    Pan: item.Pan
                                })
                            }
                        })
                    }

                    hasSubCardList.push({
                        Iban: row.row.Iban,
                        Pan: row.row.Pan,
                        SubPans: Pans
                    })

                }
            }



        } else {
            encryptedPanList.push(parentRow.EncryptedPan)

            if (parentRow.AdditionNumb > 0) {
                parentRow.AdditionCards.map((item: any) => {
                    encryptedPanList.push(item.EncryptedPan)
                })
            }
        }


        let req_data = {
            encryptedPanList: encryptedPanList
        }

        const get_card_balance = await getOldCardBalance(getCurrentCompany(), req_data);




        let new_array = tableData?.map(row => {


            let balance = row.col_7.card_balance;
            let blocked_tooltip = row.col_4.tooltip;
            let block_by_user_text = `Kart ${row?.row?.BlockedDate} tarixində tərəfinizdən bloklanıb. <br/> Blokdan çıxarmaq üçün "3 düymə"yə daxil olun.`;
            let block_by_bank_text = `Kart ${row?.row?.BlockedDate} tarixində bank tərəfindən bloklanıb. <br/> Blokdan çıxarmaq üçün banka müraciət etməyiniz xahiş olunur.`;
            let BlockedBy: any = "";
            let subCards = row.data;

            const balanceSubCard: any = [];

            if (parentRow === 'allBalance') {

                let findCurrentRowBalance = hasSubCardList?.find(cRow => cRow.Iban === row.row.Iban);


                if (findCurrentRowBalance !== undefined) {

                    let getBalance = get_card_balance?.businessCardsBalance?.CardInfoResponses?.find(bRow => bRow.Pan === findCurrentRowBalance.Pan);


                    balance = financial(getBalance?.Balance);



                    BlockedBy = getBalance?.BlockedBy;
                }

                if (row.row.AdditionNumb > 0) {
                    row.row.AdditionCards?.map((item: any, i: number) => {
                        let blocked_tooltipSubCard = row.data[i].col_4.tooltip;
                        let block_by_user_textSubCard = `Kart ${item?.BlockedDate} tarixində tərəfinizdən bloklanıb. <br/> Blokdan çıxarmaq üçün "3 düymə"yə daxil olun.`;
                        let block_by_bank_textSubCard = `Kart ${item?.BlockedDate} tarixində bank tərəfindən bloklanıb. <br/> Blokdan çıxarmaq üçün banka müraciət etməyiniz xahiş olunur.`;

                        let BlockedBySubCard: any = "";

                        if (findCurrentRowBalance.SubPans.length !== 0) {
                            findCurrentRowBalance.SubPans.map((item2: any) => {
                                let getBalance = get_card_balance?.businessCardsBalance?.CardInfoResponses?.find(bRow => bRow.Pan === item2.Pan);
                                BlockedBySubCard = getBalance?.BlockedBy;
                            })
                        }


                        blocked_tooltipSubCard = BlockedBySubCard === "" ? blocked_tooltipSubCard : BlockedBySubCard === 'User' ? block_by_user_textSubCard : block_by_bank_textSubCard;


                        balanceSubCard.push({ ...row.data[i], col_4: { ...row.data[i].col_4, tooltip: blocked_tooltipSubCard } })
                    })
                }

            }
            else {
                if (row.row.Iban === parentRow.Iban) {

                    let getBalance = get_card_balance?.businessCardsBalance?.CardInfoResponses?.find(bRow => bRow.Pan === parentRow.Pan);

                    balance = financial(getBalance?.Balance);
                    BlockedBy = getBalance?.BlockedBy;


                    if (parentRow.AdditionNumb > 0) {
                        parentRow.AdditionCards?.map((item: any, i: number) => {

                            let blocked_tooltipSubCard = row.data[i].col_4.tooltip;
                            let block_by_user_textSubCard = `Kart ${item?.BlockedDate} tarixində tərəfinizdən bloklanıb. <br/> Blokdan çıxarmaq üçün "3 düymə"yə daxil olun.`;
                            let block_by_bank_textSubCard = `Kart ${item?.BlockedDate} tarixində bank tərəfindən bloklanıb. <br/> Blokdan çıxarmaq üçün banka müraciət etməyiniz xahiş olunur.`;

                            let BlockedBySubCard: any = "";

                            let getBalance = get_card_balance?.businessCardsBalance?.CardInfoResponses?.find(bRow => bRow.Pan === item.Pan);
                            BlockedBySubCard = getBalance?.BlockedBy;


                            blocked_tooltipSubCard = BlockedBySubCard === "" ? blocked_tooltipSubCard : BlockedBySubCard === 'User' ? block_by_user_textSubCard : block_by_bank_textSubCard;


                            balanceSubCard.push({ ...row.data[i], col_4: { ...row.data[i].col_4, tooltip: blocked_tooltipSubCard } })
                        })
                    }
                }
            }

            blocked_tooltip = BlockedBy === "" ? blocked_tooltip : BlockedBy === 'User' ? block_by_user_text : block_by_bank_text;

            subCards = balanceSubCard.length !== 0 ? balanceSubCard : subCards;




            return {
                ...row,
                col_4: { ...row.col_4, tooltip: blocked_tooltip },
                col_7: { card_balance: balance },
                data: subCards

            }
        });








        let new_arrayMain = tableDataMain?.map(row => {

            let balance = row.col_7.card_balance;
            let blocked_tooltip = row.col_4.tooltip;
            let block_by_user_text = `Kart ${row?.row?.BlockedDate} tarixində tərəfinizdən bloklanıb. <br/> Blokdan çıxarmaq üçün "3 düymə"yə daxil olun.`;
            let block_by_bank_text = `Kart ${row?.row?.BlockedDate} tarixində bank tərəfindən bloklanıb. <br/> Blokdan çıxarmaq üçün banka müraciət etməyiniz xahiş olunur.`;
            let BlockedBy: any = "";
            let subCards = row.data;

            const balanceSubCard: any = [];

            if (parentRow === 'allBalance') {

                let findCurrentRowBalance = hasSubCardList?.find(cRow => cRow.Iban === row.row.Iban);


                if (findCurrentRowBalance !== undefined) {

                    let getBalance = get_card_balance?.businessCardsBalance?.CardInfoResponses?.find(bRow => bRow.Pan === findCurrentRowBalance.Pan);


                    balance = financial(getBalance?.Balance);



                    BlockedBy = getBalance?.BlockedBy;
                }

                if (row.row.AdditionNumb > 0) {
                    row.row.AdditionCards?.map((item: any, i: number) => {
                        let blocked_tooltipSubCard = row.data[i].col_4.tooltip;
                        let block_by_user_textSubCard = `Kart ${item?.BlockedDate} tarixində tərəfinizdən bloklanıb. <br/> Blokdan çıxarmaq üçün "3 düymə"yə daxil olun.`;
                        let block_by_bank_textSubCard = `Kart ${item?.BlockedDate} tarixində bank tərəfindən bloklanıb. <br/> Blokdan çıxarmaq üçün banka müraciət etməyiniz xahiş olunur.`;

                        let BlockedBySubCard: any = "";

                        if (findCurrentRowBalance.SubPans.length !== 0) {
                            findCurrentRowBalance.SubPans.map((item2: any) => {
                                let getBalance = get_card_balance?.businessCardsBalance?.CardInfoResponses?.find(bRow => bRow.Pan === item2.Pan);
                                BlockedBySubCard = getBalance?.BlockedBy;
                            })
                        }


                        blocked_tooltipSubCard = BlockedBySubCard === "" ? blocked_tooltipSubCard : BlockedBySubCard === 'User' ? block_by_user_textSubCard : block_by_bank_textSubCard;


                        balanceSubCard.push({ ...row.data[i], col_4: { ...row.data[i].col_4, tooltip: blocked_tooltipSubCard } })
                    })
                }

            }
            else {
                if (row.row.Iban === parentRow.Iban) {
                    let getBalance = get_card_balance?.businessCardsBalance?.CardInfoResponses?.find(bRow => bRow.Pan === parentRow.Pan);

                    balance = financial(getBalance?.Balance);
                    BlockedBy = getBalance?.BlockedBy;


                    if (row.row.AdditionNumb > 0) {
                        row.row.AdditionCards?.map((item: any, i: number) => {

                            let blocked_tooltipSubCard = row.data[i].col_4.tooltip;
                            let block_by_user_textSubCard = `Kart ${item?.BlockedDate} tarixində tərəfinizdən bloklanıb. <br/> Blokdan çıxarmaq üçün "3 düymə"yə daxil olun.`;
                            let block_by_bank_textSubCard = `Kart ${item?.BlockedDate} tarixində bank tərəfindən bloklanıb. <br/> Blokdan çıxarmaq üçün banka müraciət etməyiniz xahiş olunur.`;

                            let BlockedBySubCard: any = "";

                            let getBalance = get_card_balance?.businessCardsBalance?.CardInfoResponses?.find(bRow => bRow.Pan === item.Pan);
                            BlockedBySubCard = getBalance?.BlockedBy;


                            blocked_tooltipSubCard = BlockedBySubCard === "" ? blocked_tooltipSubCard : BlockedBySubCard === 'User' ? block_by_user_textSubCard : block_by_bank_textSubCard;


                            balanceSubCard.push({ ...row.data[i], col_4: { ...row.data[i].col_4, tooltip: blocked_tooltipSubCard } })
                        })
                    }
                }
            }

            blocked_tooltip = BlockedBy === "" ? blocked_tooltip : BlockedBy === 'User' ? block_by_user_text : block_by_bank_text;

            subCards = balanceSubCard.length !== 0 ? balanceSubCard : subCards;




            return {
                ...row,
                col_4: { ...row.col_4, tooltip: blocked_tooltip },
                col_7: { card_balance: balance },
                data: subCards

            }
        });



        setTableData(old_data => new_array);
        setTableDataForSort(old_data => new_array)
        setTableDataMain(old_data => new_arrayMain);

        setTableLoading({
            ...tableLoading,
            spinning: false
        });



    }
    const handleModalClose = () => {
        setRequisiteModalVisible(false)
    }
    const modalDataRequisite = () => {
        return requisiteData?.rekvizitAzn && requisiteData?.rekvizitAzn[0]?.ccyType === "AZN" ? {
                modalTitle: `${t("requisites.accountDetails")}: ${titleRequisiteState[0] ?? ''} ${titleRequisiteState[1] ?? ''} ${titleRequisiteState[2] ?? ''}`,
                groups: [
                    {
                        title: t("requisites.bankAccountDetails"),
                        tableHasBorderBottom: false,
                        data: [
                            {
                                label: t("requisites.customer"),
                                value: requisiteData?.customerName ?? ''
                            },
                            {
                                label: t("requisites.legalAddress"),
                                value: requisiteData?.customerAddress ?? ''
                            },
                            {
                                label: t("requisites.customerBank"),
                                value: requisiteData?.bankName ?? ''
                            },
                            {
                                label: t("requisites.taxID"),
                                value: requisiteData?.bankVoen ?? ''
                            },
                            {
                                label: t("requisites.legalAddress"),
                                value: requisiteData?.bankAddress ?? ''
                            },
                            {
                                label: t("requisites.phone"),
                                value: requisiteData?.bankPhone ?? ''
                            },
                            {
                                label: t("requisites.email"),
                                value: requisiteData?.bankEmail ?? ''
                            },
                        ],
                    },
                    {
                        title: t("requisites.beneficiary"),
                        tableHasBorderBottom: false,
                        tableHasMarginBottom: true,
                        currency: titleRequisiteState[2] ?? '',
                        data: [
                            {
                                label: t("requisites.name"),
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.customerName : '',
                            },
                            {
                                label: t("requisites.taxID"),
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.customerVoen : '',
                            },
                            {
                                label: 'IBAN',
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.iban : '',
                            }
                        ],
                    },
                    {
                        title: t("requisites.beneficiaryBank"),
                        tableHasBorderBottom: false,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("requisites.name"),
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.bankName : '',
                            },
                            {
                                label: t("requisites.code"),
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.bankCode : '',
                            },
                            {
                                label: t("requisites.mH"),
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.bankAccount : '',
                            },
                            {
                                label: 'SWIFT',
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.bankSwift : '',
                            },
                        ],
                    }
                ],
                buttons: [
                    { selectAccount: true }
                ],
            } :
            {
                modalTitle: `${t("requisites.accountDetails")}: ${titleRequisiteState[0] ?? ''} ${titleRequisiteState[1] ?? ''} ${titleRequisiteState[2] ?? ''}`,
                groups: [
                    {
                        title: t("requisites.bankAccountDetails"),
                        tableHasBorderBottom: false,
                        data: [
                            {
                                label: t("requisites.customer"),
                                value: requisiteData?.customerName ?? ''
                            },
                            {
                                label: t("requisites.legalAddress"),
                                value: requisiteData?.customerAddress ?? ''
                            },
                            {
                                label: t("requisites.customerBank"),
                                value: requisiteData?.bankName ?? ''
                            },
                            {
                                label: t("requisites.taxID"),
                                value: requisiteData?.bankVoen ?? ''
                            },
                            {
                                label: t("requisites.legalAddress"),
                                value: requisiteData?.bankAddress ?? ''
                            },
                            {
                                label: t("requisites.phone"),
                                value: requisiteData?.bankPhone ?? ''
                            },
                            {
                                label: t("requisites.email"),
                                value: requisiteData?.bankEmail ?? ''
                            },
                        ],
                    },
                    {
                        title: t("requisites.beneficiary"),
                        tableHasBorderBottom: false,
                        tableHasMarginBottom: true,
                        currency: titleRequisiteState[2] ?? '',
                        data: [
                            {
                                label: t("requisites.name"),
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.customerName : '',
                            },
                            {
                                label: t("requisites.taxID"),
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.customerVoen : '',
                            },
                            {
                                label: 'IBAN',
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.iban : '',
                            }
                        ],
                    },
                    {
                        title: t("requisites.beneficiaryBank"),
                        tableHasBorderBottom: false,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("requisites.name"),
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.bankName : '',
                            },
                            {
                                label: t("transfers.address"),
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.bankAddress : '',
                            },
                            {
                                label: 'SWIFT',
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.bankSwift : '',
                            },
                        ],
                    },
                    {
                        title: t("newTransfer.intermediaryBank"),
                        tableHasBorderBottom: false,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("requisites.name"),
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.muhbirName : '',
                            },
                            {
                                label: t("transfers.address"),
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.muhbirAddress : '',
                            },
                            {
                                label: 'SWIFT',
                                value: requisiteData?.rekvizitAzn ? requisiteData?.rekvizitAzn[0]?.muhbirSwift : '',
                            },
                        ],
                    }
                ],
                buttons: [
                    { selectAccount: true }
                ],
            }
    }
    return (
        <>

            <Form
                form={form}
            >

                {
                    tableDataMain?.length > 0 && <TableComponent
                        loading={tableLoading}
                        columns={accountTableColumns}
                        className=" transfer-table table-hover home_hesab_table  home_content_table business_cards_table business_cards_table_1 voen_cards_table"
                        data={tableData}
                        scroll={{ x: true }}
                        pagination={false}
                        pageSize={3}
                        position={'center'}
                        alignment={'bottom'}
                        expandable={expandedRowRender()}
                        rowClassName={(record, index) => expandedRowKeys.indexOf(record.key) !== -1 ? ' opened_row ' : ''}
                    />
                }

                {
                    tableDataMain?.length === 0 && <div className={'full flex justify_center table_no_data flex_wrap'}><h3>{t("businessCards.noBusinessCard")}</h3></div>
                }

            </Form>


            {
                visibleBlockUnblockCardModal && <EnableOrDisableServiceModal
                    visible={visibleBlockUnblockCardModal}
                    onClose={setVisibleBlockUnblockCardModal}
                    serviceType={blockOrUnblockServicePopupData.serviceType}
                    activateBtnText={blockOrUnblockServicePopupData.activateBtnText}
                    modalTitle={blockOrUnblockServicePopupData.modalTitle}
                    modalText={blockOrUnblockServicePopupData.modalText}
                    successModalTitle={blockOrUnblockServicePopupData.successModalTitle}
                    successModalText={blockOrUnblockServicePopupData.successModalText}
                />
            }

            {
                visibleResetPinModal && <EnableOrDisableServiceModal
                    visible={visibleResetPinModal}
                    onClose={setVisibleResetPinModal}
                    serviceType={'activate'}
                    activateBtnText={t("businessCards.reset")}
                    modalTitle={t("businessCards.resetPINEntryAttempt")}
                    modalText={t("businessCards.attemptInfo")}
                    successModalTitle={t("businessCards.isReady")}
                    successModalText={t("businessCards.resetedPINEntryAttempt")}
                />
            }

            {
                visibleSmsNotifModal && <EnableOrDisableServiceModal
                    visible={visibleSmsNotifModal}
                    onClose={setVisibleSmsNotifModal}
                    serviceType={'activate'}
                    modalTitle={t("notification.attention")}
                    modalText={t("businessCards.SMSNotificationInfo")}
                    successModalTitle={t("businessCards.isReady")}
                    successModalText={t("businessCards.SMSNotificationActivated")}
                />
            }
            {requisiteModalVisible &&
                <NextModal
                    // btnType={'APPROVE'}
                    // requestType={requestType}
                    // disabledSign={props.disabledSign}
                    // onStatusChange={props.handleStatusChange}
                    // nextModalText={'Köçürmələr qrupu banka göndərilir. Nəticəni “Köçürmələr”də izləyə bilərsiniz.'}
                    // callBackApi={newTransferFunc}
                    visible={requisiteModalVisible}
                    data={modalDataRequisite()}
                    // // tableTitle ={props.type == 'common' ? '' : t("transfers.transferHistory") }
                    // columnsData={columnsData}
                    // tableData={props.tableData['SIGN_DETAIL']}
                    // type={props.type}
                    onClose={handleModalClose}
                    // innerColumnsdata={innerColumnsdata}
                    // innerrtableData={props.innerrtableData}
                    // transferData={props.type == 'common' ? false : true}
                    className={'flex_middle rekvizit_modal'}
                    source={'requiste'}
                    otherButtons={footerBtnsSecondModal}
                />
        }


        </>
    )
}

const mapDispatchToProps = {getRequisiteData}
const mapStateToProps = (state: any) => ({
    companyData: (state.user && state.user.companyData.result) ? state.user.companyData.result.customerNo : getCurrentCompany(),
    requisiteData: state.accountsStatement.requisiteData.result ?? [],

})
export default connect(mapStateToProps, mapDispatchToProps)(IndividualCard)
